export enum TransactionType {
  Debit = 'debit',
  Credit = 'credit',
}
